import React from 'react';
import { useLanguage } from '../../context/language-context-provider';
const SocialStatistics = () => {
  const {
    t
  } = useLanguage();
  return <div className='mx-auto grid w-fit grid-cols-2 gap-6 py-5.5 lg:py-6' data-sentry-component="SocialStatistics" data-sentry-source-file="social.tsx">
            <div className='item col-span-2'>
                <span className='title'>{t('statistics.social.item1.title')}</span>
                <span className='value'>{t('statistics.social.item1.text')}</span>
            </div>
            <div className='item'>
                <span className='title'>{t('statistics.social.item2.title')}</span>
                <span className='value'>{t('statistics.social.item2.text')}</span>
            </div>
            <div className='item'>
                <span className='title'>{t('statistics.social.item3.title')}</span>
                <span className='value'>{t('statistics.social.item3.text')}</span>
            </div>
        </div>;
};
export default SocialStatistics;